import { getModernInlineSignatureImages, } from "./signatureIconAssets";
import { buildModernTemplate } from "./templates/template-modern";
import { buildClassicTemplate } from "./templates/template-classic";
const PHOTO_CID_BASENAME = "sig-photo";
const DEFAULT_PHOTO_CID_FILENAME = `${PHOTO_CID_BASENAME}.jpg`;
const DEFAULT_PREFS = {
    template: "modern",
    overrides: {},
    autoInsert: true,
};
/**
 * Assembles the final signature HTML from the Graph profile + photo + user prefs.
 *
 * @param graphUser  - Raw response from GET /me
 * @param photoDataUri - Base64 data URI from profilePhoto.ts
 * @param prefs - User-saved preferences from localStorage
 */
export function buildSignatureHtml(graphUser, photoDataUri, prefs = {}, options = {}) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const mergedPrefs = Object.assign(Object.assign({}, DEFAULT_PREFS), prefs);
    const iconMode = (_a = options.iconMode) !== null && _a !== void 0 ? _a : "dataUri";
    const photoCidFilename = (_b = options.photoCidFilename) !== null && _b !== void 0 ? _b : DEFAULT_PHOTO_CID_FILENAME;
    const resolved = {
        displayName: (_c = graphUser.displayName) !== null && _c !== void 0 ? _c : "Unknown",
        givenName: (_d = graphUser.givenName) !== null && _d !== void 0 ? _d : "",
        surname: (_e = graphUser.surname) !== null && _e !== void 0 ? _e : "",
        jobTitle: (_f = graphUser.jobTitle) !== null && _f !== void 0 ? _f : "",
        department: (_g = graphUser.department) !== null && _g !== void 0 ? _g : "",
        companyName: (_h = graphUser.companyName) !== null && _h !== void 0 ? _h : "",
        email: (_j = graphUser.mail) !== null && _j !== void 0 ? _j : graphUser.userPrincipalName,
        mobilePhone: (_k = graphUser.mobilePhone) !== null && _k !== void 0 ? _k : "",
        directPhone: (_m = (_l = graphUser.businessPhones) === null || _l === void 0 ? void 0 : _l[0]) !== null && _m !== void 0 ? _m : "",
        officeLocation: (_o = graphUser.officeLocation) !== null && _o !== void 0 ? _o : "",
        streetAddress: (_p = graphUser.streetAddress) !== null && _p !== void 0 ? _p : "",
        city: (_q = graphUser.city) !== null && _q !== void 0 ? _q : "",
        state: (_r = graphUser.state) !== null && _r !== void 0 ? _r : "",
        postalCode: (_s = graphUser.postalCode) !== null && _s !== void 0 ? _s : "",
        country: (_t = graphUser.country) !== null && _t !== void 0 ? _t : "",
        photoDataUri: iconMode === "cid" ? `cid:${photoCidFilename}` : photoDataUri,
    };
    switch (mergedPrefs.template) {
        case "classic":
            return buildClassicTemplate(resolved, mergedPrefs);
        case "modern":
        default:
            return buildModernTemplate(resolved, mergedPrefs, iconMode);
    }
}
export function getSignatureInlineImages(prefs = {}) {
    const mergedPrefs = Object.assign(Object.assign({}, DEFAULT_PREFS), prefs);
    if (mergedPrefs.template !== "modern") {
        return [];
    }
    return getModernInlineSignatureImages();
}
export function getSignaturePhotoInlineImage(photoDataUri, fileName = DEFAULT_PHOTO_CID_FILENAME) {
    const base64Content = extractBase64ContentFromDataUri(photoDataUri);
    return { fileName, base64Content };
}
export function createSignaturePhotoCidFilename(photoDataUri) {
    const extension = getImageExtensionFromDataUri(photoDataUri);
    const uniqueSuffix = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    return `${PHOTO_CID_BASENAME}-${uniqueSuffix}.${extension}`;
}
function extractBase64ContentFromDataUri(dataUri) {
    const commaIndex = dataUri.indexOf(",");
    if (commaIndex === -1) {
        throw new Error("Invalid photo data URI");
    }
    const metadata = dataUri.slice(0, commaIndex);
    const payload = dataUri.slice(commaIndex + 1);
    if (/;base64$/i.test(metadata)) {
        return payload;
    }
    const decodedPayload = decodeURIComponent(payload);
    return encodeUtf8ToBase64(decodedPayload);
}
function getImageExtensionFromDataUri(dataUri) {
    var _a, _b;
    const mimeMatch = dataUri.match(/^data:([^;,]+)/i);
    const mimeType = (_b = (_a = mimeMatch === null || mimeMatch === void 0 ? void 0 : mimeMatch[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "image/jpeg";
    switch (mimeType) {
        case "image/png":
            return "png";
        case "image/gif":
            return "gif";
        case "image/svg+xml":
            return "svg";
        default:
            return "jpg";
    }
}
function encodeUtf8ToBase64(value) {
    const bytes = new TextEncoder().encode(value);
    let binary = "";
    for (const byte of bytes) {
        binary += String.fromCharCode(byte);
    }
    return btoa(binary);
}
